// extracted by mini-css-extract-plugin
export default {"containerMenu":"styleMenuSuperiorMobile_containerMenu__Mudrc","hamb":"styleMenuSuperiorMobile_hamb__H2Y0C"};